import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { useSelector, useDispatch } from 'react-redux';
import { postCampaignData, postABTestCampaign, putCampaignData } from 'api/CampaignApi';
import {
  setCampaignId,
  setBackfromCampaign,
  setComplaiceStatus,
  setCampaignABTestId,
  setCurrentABTestCampaign,
  setCategory
} from 'ReduxStore/Slices/campaignSlice';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import CampaignViewDesign from './CampaignViewDesign';
import{
  setwordpressFlag
} from "ReduxStore/Slices/campaignSlice";
import { getAllApps } from "api/AppsApi";
import {GET , POST , PUT} from '../../../api/API'
import { getCompanySettings } from 'api/SettingsApi';
import { setReferralName, setReferralId } from 'ReduxStore/Slices/campaignSlice';
import { getCampaignInfo } from 'api/CampaignApi';

export default function CampaignContent({ htmlData, abTestHtmlData }) {
  const [referralList, setReferralList] = useState([
    { label: "Please Select", value: "" },
  ]);
  const history = useHistory();
  const {
    campaignId,
    campaignType,
    campaignName,
    campaignDescription,
    campaignSubject,
    campignTemplateId,
    campaignAudienceId,
    referralId,
    referralName,
    campaignEmail,
    campaignABTestEnabled,
    campaignABTestChecked,
    campaingABTestData,
    campaignViewMode,
    wordpressFlag,
    category,
  } = useSelector((state) => state.campaignSetter);
  const [isWordpressEnabled , setisWordpressEnabled] = useState(false)

  const [users, setUsers] = useState([]);
  const [referral, setReferral] = useState(false);

  useEffect(() => {

    getAllApps()
    .then((data) => {
      data.find((item) => item.key === "Wordpress").isConfigured ? setisWordpressEnabled(true) : setisWordpressEnabled(false)
   
      console.log(`data.find((item) => item.key === "Wordpress").isConfigured`,data.find((item) => item.key === "Wordpress").isConfigured, category)
    })
    .catch((e) => { 
      setisWordpressEnabled(false)
    });


  }, [])

  useEffect(() => {
    console.log("Users List => ", users);
  }, [users])

  useEffect(() => {
    GET("users")
    .then((data) => {
      const names = data.map(item => ({
        id: item.id,
        name: item.name
      }));
      setUsers(names);
      console.log("DAAAAAAATA => ", data);
      console.log("DAAAAAAATA Names => ", names);
      console.log("Userssssss DAAAAAAATA => ", users);

    })
    .catch(err => {
      console.log("ERROR => ", err);
    })
  },[])

  useEffect(() => {

    console.log("ReferralId val => ", referralId);
    console.log("Referral Name => ", referralName);
    let refi = [];
    var i = 0;
    GET("users")
    .then((data) => {
      data.map((us) => {
        if(referralId === us.id) {
          dispatch(setReferralName(us.name))
        }
        i++;
        refi.push({
          label: us.name,
          value: us.id
        })

        if (data.length === i) {
          setReferralList(refi);
        }
      })
    })
    .catch((e) => { })
  }, [referralId, referralName]);


  useEffect(() => {
    getCompanySettings()
      .then((data) =>  {
          console.log("Settings Data in Create Campaign", data);

          let e = data.settings.find(e => e.metadata.key == 'referral')

          console.log("Referral Val => ", e);
          if (e.value && e.value == true) {
            setReferral(true);
          }
      })
      .catch((e) => { })
  }, [])

  const userData = useSelector((state) => state.userSetter);
  const dispatch = useDispatch();

  const campaignData = useSelector((state) => state.campaignSetter);

  console.log("Campaign Data is  => ", campaignData);

  const createCampaign = async () => {
    var data = {
      name: campaignName,
      description: campaignDescription,
      subject: campaignSubject,
      data: '',
      templateId: campignTemplateId,
      audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
      fromEmail: campaignEmail,
      type: campaignType,
      referralId: referralId,
      isDraft: true,
      wordpressFlag :wordpressFlag
    };

    await postCampaignData(data)
      .then((res) => {
        dispatch(setCampaignId(res.id));
        dispatch(setComplaiceStatus(res.complianceStatus));
        dispatch(setCategory(res.category));
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const createABTestCampaign = () => {
    var abTestCampaignAData = {
      name: campaignName,
      description: campaignDescription,
      subject: campaignSubject,
      data: '',
      templateId: campignTemplateId,
      audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
      fromEmail: campaignEmail,
      type: campaignType,
      isDraft: true,
      isABTest: true,
      ABTestData: {
        variationType: campaingABTestData.campaignABTestVariation,
        samplePercentage: campaingABTestData.campaignABTestPercentage,
        waitTime: campaingABTestData.campaignABTestWaitTime,
        subject: campaingABTestData.campaignABTestSubject,
        decidingParameter: campaingABTestData.campaignABTestDecidingParameter,
      },
    };
    postABTestCampaign(abTestCampaignAData)
      .then((res) => {
        dispatch(setCampaignABTestId(res.ABTestData.ABTestCampaignId));
        dispatch(setCampaignId(res.id));
        dispatch(setComplaiceStatus(res.complianceStatus));
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const isValidCampaign = () => {

    if (campaignABTestEnabled && campaignABTestChecked) {
      if (campaingABTestData.campaignABTestVariation === "" || campaingABTestData.campaignABTestDecidingParameter === "") {
        toast.error('Please fill all the fields');
        return false
      } else {
        if (campaingABTestData.campaignABTestVariation === "Subject") {
          if (campaignSubject == campaingABTestData.campaignABTestSubject) {
            toast.error("Subject A and Subject B should not be same");
            return false
          }
        } if (campaignAudienceId === '' || campaignAudienceId === null) {
          toast.error('Please Select Audience');
          return false
        } else if (campaignEmail === '' || campaignEmail === null) {
          toast.error('Please Enter From Email');
          return false
        } else if (campaignSubject === '' || campaignSubject === null) {
          toast.error('Please Enter subject line for Campaign');
          return false
        }
        return true
      }
    } else {
      if (campaignType === "email") {
        if (campaignAudienceId === '' || campaignAudienceId === null) {
          toast.error('Please Select Audience');
          return false
        } else if (campaignEmail === '' || campaignEmail === null) {
          toast.error('Please Enter From Email');
          return false
        } else if (campaignSubject === '' || campaignSubject === null) {
          toast.error('Please Enter subject line for Campaign');
          return false
        }
      }
      return true
    }
  }

  const handleDesignClick = (e) => {
    if (e.target.value === 'Design') {
      dispatch(setCurrentABTestCampaign('A'));
    } else if (e.target.value == "Design A") {
      dispatch(setCurrentABTestCampaign('A'));
    } else if (e.target.value == "Design B") {
      dispatch(setCurrentABTestCampaign('B'));
    }

    if (e.target.value === 'View Design') {
      dispatch(setCurrentABTestCampaign('A'));
    } else if (e.target.value == "View Design A") {
      dispatch(setCurrentABTestCampaign('A'));
    } else if (e.target.value == "View Design B") {
      dispatch(setCurrentABTestCampaign('B'));
    }


    if (campaignABTestEnabled && campaignABTestChecked) {
      if (!campaignId) {
        if (isValidCampaign()) {
          createABTestCampaign()
          history.push(`/admin/templates/select`);
        }
      } else {
        dispatch(setBackfromCampaign(true));
        var abTestCampaignAData = {
          name: campaignName,
          description: campaignDescription,
          subject: campaignSubject,
          data: '',
          templateId: campignTemplateId,
          audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
          fromEmail: campaignEmail,
          type: campaignType,
          isDraft: true,
          isABTest: true,
          referralId: referralId,
          ABTestData: {
            variationType: campaingABTestData.campaignABTestVariation,
            samplePercentage: campaingABTestData.campaignABTestPercentage,
            waitTime: campaingABTestData.campaignABTestWaitTime,
            subject: campaingABTestData.campaignABTestSubject,
            decidingParameter: campaingABTestData.campaignABTestDecidingParameter,
          },
        };
        if (isValidCampaign()) {
          if (
            userData.role === 'compliance' &&
            userData.companyLevelComplaiceFlag === true
          ) {
            putCampaignData(abTestCampaignAData, campaignId).then((data) => {
              history.push(`/admin/templates/create`);
            })
              .catch((err) => {
                toast.error("Something went wrong");
              });
          } else {
            putCampaignData(abTestCampaignAData, campaignId).then((data) => {
              history.push(`/admin/templates/select`);
            })
              .catch((err) => {
                toast.error("Something went wrong");
              });
          }
        }

      }
    } else {
      if (!campaignId) {
        if (isValidCampaign()) {
          createCampaign();
          history.push(`/admin/templates/select`);
        }
      } else {
        dispatch(setBackfromCampaign(true));
        var data = {
          name: campaignName,
          description: campaignDescription,
          subject: campaignSubject,
          data: '',
          templateId: campignTemplateId,
          audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
          fromEmail: campaignEmail,
          type: campaignType,
          isDraft: true,
          referralId: referralId,
        };

        if (isValidCampaign()) {
          if (
            userData.role === 'compliance' &&
            userData.companyLevelComplaiceFlag === true
          ) {
            putCampaignData(data, campaignId).then((data) => {
              history.push(`/admin/templates/create`);
            })
              .catch((err) => {
                toast.error("Something went wrong");
              });

          } else {
            putCampaignData(data, campaignId).then((data) => {
              history.push(`/admin/templates/select`);
            })
              .catch((err) => {
                toast.error("Something went wrong");
              });
          }
        }

      }
    }
  };
  return (
    <>
    {
      referral ?      
        <div style={{ marginTop: "35px", maxWidth: "780px", width: "100%", display: "flex", justifyContent: "space-between" }}>
          <label className="large">Referrer</label>
          <div style={{maxWidth: "486px", minWidth: '170px'}} >
            <Select
              id="referralId"
              isClearable
              value={{
                value: referralId,
                label: referralName,
              }}
              onChange={(e, {action}) => {
                console.log("The value of e on change => ", e);
                dispatch(setReferralId(null));
                dispatch(setReferralName(null));
                if (action == "clear") {
                  sessionStorage.setItem("referralId", null);
                  sessionStorage.setItem("referralName", null);
                }
                if (e !== null) {
                  sessionStorage.setItem("referralId", e.value);
                  sessionStorage.setItem("referralName", e.label);
                  dispatch(setReferralId(e.value));
                  dispatch(setReferralName(e.label));
                  console.log("referralName => ", e.label);
                  console.log("referralId => ", e.value);
                }
                dispatch(setReferralId(e.value));
                dispatch(setReferralName(e.label));

              }}
              // id="selectUsers"
              // className="kwDesign2 w486"
              options={referralList}
              required
              isDisabled={campaignViewMode}
            />
          </div>
        </div>
        : ""
    }
    <div className='row justify-content-between align-items-end pt_15'>
      <div className='left_sec'>
        <div className='max534'>
          <label>Content</label>
          <p className='campaign_text'>Design the content</p>
        </div>
      </div>
      <div className='right_sec'>
        {campaignABTestEnabled &&
          campaignABTestChecked &&
          campaingABTestData.campaignABTestVariation === 'Content' ? (
          <>
            <input
              onClick={(e) => {
                if (!campaignViewMode) {
                  campaingABTestData.campaignABTestWaitTime >= 0.5 ?
                    handleDesignClick(e) : toast.error('Wait time should be greater than or equal to 0.5')
                } else {
                  dispatch(setCurrentABTestCampaign('A'));
                }
              }}
              type={'submit'}
              className='lg_btn primary '
              value={
                (userData.role === 'compliance') || campaignViewMode ? 'View Design A' : 'Design A'
              }
              data-toggle={campaignViewMode && 'modal'}
              data-target={campaignViewMode && `#campaignDesignView`}
            />
            <input
              onClick={(e) => {
                if (!campaignViewMode) {
                  campaingABTestData.campaignABTestWaitTime >= 0.5 ?
                    handleDesignClick(e) : toast.error('Wait time should be greater than or equal to 0.5')
                } else {
                  dispatch(setCurrentABTestCampaign('B'));
                }
              }}
              type={'submit'}
              className='lg_btn primary  ml-2'
              value={
                (userData.role === 'compliance') || campaignViewMode ? 'View Design B' : 'Design B'
              }
              data-toggle={campaignViewMode && 'modal'}
              data-target={campaignViewMode && `#campaignDesignView`}
            />
          </>
        ) : (
          <input
            onClick={(e) => {
              if (!campaignViewMode) {
                if (campaignABTestEnabled &&
                  campaignABTestChecked) {
                  campaingABTestData.campaignABTestWaitTime >= 0.5 ?
                    handleDesignClick(e) : toast.error('Wait time should be greater than or equal to 0.5')
                } else {
                  handleDesignClick(e);
                }
              }
            }}
            type={'submit'}
            className='lg_btn primary'
            value={(userData.role === 'compliance') || campaignViewMode ? 'View Design' : 'Design'}
            data-toggle={campaignViewMode && 'modal'}
            data-target={campaignViewMode && `#campaignDesignView`}
          />
        )}
        <CampaignViewDesign htmlData={htmlData} abTestHtmlData={abTestHtmlData} />
      </div>



    </div>

    {campaignType != "email" && isWordpressEnabled && category =='Blogs' && <div className='row justify-content-between align-items-end pt_15'>
    <div className='left_sec'>
        <div className='max534'
        style={{
          display: "flex",
          alignItems: "center"
        }}
        
        >
        <input
          checked={wordpressFlag}
          onChange={(e) => {
            console.log("setwordpressFlagsetwordpressFlag",e.target.checked)
            dispatch(setwordpressFlag(e.target.checked));
          }}
          style={{
              padding: "20px",
              height: "40px",
              width: "20px",
              marginRight: "10px"
          }}

            type="checkbox"
            id="checkboxi1"
          />
          <p className='campaign_text'>Publish to Wordpress</p>
        </div>
      </div>
      <div>
 
      </div>

    </div>
}
      {/* <div style={{ fontSize: '16px',
      margin: '27px 0px 0px 0px',
      fontWeight: '900' }}
      >
        Scheduled to run on: Date and Time
    </div> */}
    </>
  );
}
